<template>

  <div class="card card-front front-card">
    <header class="card-header">
      <div class="status right-status" :style="{'background-color': $store.getters.getStatusOfRoom(room.did).color}"></div>
      <div class="ob-header card-header" style="margin:0px;">
        <div class="card-title">
          <h3>{{clauses.maint}}</h3>
          <h6>{{truncate(room.info.hvacName, 30, 27)}}</h6>
          <h6 style="color:lightblue;" v-if="room.info.apid">{{clauses.serial}}: {{room.info.apid}}</h6>
        </div>
        <div class="ob-img">
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/maint.png" />
        </div>
      </div>
      <div class="card-head-sep"></div>
    </header>
    <div class="card-body side-body">
      <div class="card-info double-info">
        <div class="maint-header">
          <div :class="active === 'alerts' ? 'maint-node active-maint-node' : 'maint-node'" @click="active = 'alerts'">
            <h5>{{clauses.alerts}}</h5>
          </div>
          <div :class="active === 'sched' ? 'maint-node active-maint-node' : 'maint-node'" @click="active = 'sched'">
            <h5>{{clauses.sched}}</h5>
          </div>
        </div>
        <div class="card-head-sep" style="margin-top:10px;"></div>
        <div class="maint-body" v-if="active === 'alerts'">
          <h5 v-if="!compileAlerts.length">No Current Alerts</h5>
          <div v-for="alert in compileAlerts" class="alert-node" :style="{'border': `1px solid ${alert.crit ? 'red' : '#E6A752'}`}">
            <div class="alert-head" :style="{'background-color': alert.crit ? 'red' : '#E6A752'}">
              <img :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${rdgDetails(alert).img}.png`" />
            </div>
            <h5>{{rdgDetails(alert).label}}</h5>
          </div>
        </div>
        <div class="maint-body" style="justify-content:center;align-items:center;margin-bottom:15%;" v-else>
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/comingSoon.png" />
        </div>
      </div>
    </div>
    <toggle-component :curr="2" v-on:flip="$emit('initFlip', {from: 'left', to: $event})"></toggle-component>
  </div>

</template>

<script>

import Lang from '@/lib/langTemplates/CardTemplate';

import Toggle from './Toggle';

export default {

  data(){
    return {
      active: 'alerts'
    }
  },

  props: ['room', 'status'],

  components: {
    'toggle-component': Toggle
  },

  computed: {
    compileAlerts(){
      return this.$store.getters.getRoomAlerts(this.room.did);
    },
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    truncate(name, max, end){
      return name.length < max ? name : name.substr(0, end) + '...'
    },

    rdgDetails(r){
      // if (r !== 'voc') {
        switch (r.rdg) {
          case 'days':
            return {
              img: 'filterOfficial',
              label: `${r.crit ? this.clauses.crit : this.clauses.warn} ${this.clauses.filter} ${this.clauses.alert}`
            }
          break;
          case 'ttp':
            return {
              img: 'temp',
              label: `${r.crit ? this.clauses.crit : this.clauses.warn} ${this.clauses.temp} ${this.clauses.alert}`
            }
          break;
          case 'hhm':
            return {
              img: 'hum',
              label: `${r.crit ? this.clauses.crit : this.clauses.warn} ${this.clauses.hum} ${this.clauses.alert}`
            }
          break;
          case 'iaq':
            return {
              img: 'tvocNoText',
              label: `${r.crit ? this.clauses.crit : this.clauses.warn} IAQ ${this.clauses.alert}`
            }
          break;
          case 'co2':
          return {
            img: 'eCO2Text',
            label: `${r.crit ? this.clauses.crit : this.clauses.warn} ${this.clauses.co2} ${this.clauses.alert}`
          }
          break;
          default:
          return {
            img: 'tvocWithText',
            label: `${r.crit ? this.clauses.crit : this.clauses.warn} tVOC ${this.clauses.alert}`
          }
        }
      // }
    }

  },

  mounted(){

  }

}

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/card/Left.vue